import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdConfirmationNumber } from 'react-icons/md';

import { useFormikContext } from 'formik';

import SettingsOption, { OptionType } from '../SettingsOption';
import MaxTicketsModal from './MaxTicketsModal';

const MaxTicketsSettings = () => {
  const { t } = useTranslation(['events']);
  const { values, setFieldValue } = useFormikContext<any>();

  const [showMaxTicketsModal, setShowMaxTicketsModal] = useState(false);

  const toggleMaxTicketsModal = () => {
    setShowMaxTicketsModal((showMaxTicketsModal) => !showMaxTicketsModal);
  };

  const onSave = (maxTicketsPerTransaction: string) => {
    setFieldValue('maxTicketsPerTransaction', maxTicketsPerTransaction);
  };

  return (
    <>
      <SettingsOption
        icon={<MdConfirmationNumber size={20} />}
        title={t('events:settings.maxTickets.title')}
        actionLabel={t('events:settings.maxTickets.actionLabel')}
        value={values?.maxTicketsPerTransaction}
        onClick={toggleMaxTicketsModal}
        tooltipMessage={t('events:settings.maxTickets.tooltip')}
        type={OptionType.Button}
      />

      {showMaxTicketsModal && (
        <MaxTicketsModal
          onClose={toggleMaxTicketsModal}
          onSave={onSave}
          initialValues={{
            maxTicketsPerTransaction: values?.maxTicketsPerTransaction || ''
          }}
        />
      )}
    </>
  );
};

export default MaxTicketsSettings;
